$(document).ready(function () {
    $(document).on('click', '.js__open_filial', function () {
        var $button = $(this);
        var $fullText = $button.closest('.good_page_info_text_wrapper').find('.js__full_text');

        $fullText.css({
            'top': $button.outerHeight() + 40,
        });

        $fullText.stop(true, true).slideToggle('slow');
    });

    $(document).on('click', function (e) {
        var $target = $(e.target);
        if (!$target.closest('.good_page_info_desc').length && !$(e.target).hasClass('js__open_filial')) {
            $('.js__full_text').slideUp('slow');
        }
    });

    $(document).on('click', '.js_count_goods button', function () {
        const nameButton = $(this).attr('data-name');
        const parent = $(this).closest('.js_count_goods');
        const input = $(this).closest('.js_count_goods').find('.js__count_input');
        const maxPrise = input.attr('data-maxCount');
        const minPrise = input.attr('data-minCount');
        const value = Number(input.val());
        let garantyKey = false;


        if ($(this).closest('.js_count_goods').hasClass('js__garanty_count') && $(this).closest('.js__update_block_gtm').find('.js__garanty_cart').is(':checked')) {
            garantyKey = $(this).closest('.js__garanty_count').attr('data-garanty_key');
        }

        $(this).closest('.js_count_goods').find('button').removeClass('disabled');

        if (nameButton == 'count_plus') {
            if (maxPrise && (maxPrise <= value)) {
                input.val(maxPrise);
                $(this).addClass('disabled');
            } else {
                if (value + 1 == maxPrise) {
                    input.val(value + 1);
                    $(this).addClass('disabled');
                } else {
                    input.val(value + 1);
                }
            }
        } else {
            if (minPrise && (minPrise >= value)) {
                input.val(minPrise);
                $(this).addClass('disabled');
            } else if (value > 1) {
                if (value - 1 == 1) {
                    input.val(value - 1);
                    $(this).addClass('disabled');
                } else {
                    input.val(value - 1);
                }
            }
        }

        if ($('.js__good_page_quantity').length > 0) {
            $('.js__quantity_boc').val($('.js__good_page_quantity').val());
        }

        if (parent.hasClass('js__cart_modal')) {
            const dataQuantity = {
                "id_cart": `${input.attr('data-idCart')}`,
                "quantity": `${input.val()}`
            }
            const typeCart = $(this).closest('.js__type_cart').attr('data-type');

            $.post(request.updateGoodQuantity, {
                "id_cart": dataQuantity['id_cart'],
                "quantity": dataQuantity['quantity'],
                "cart_good_guids": toolsCartGoodsBuy.getGoods(),
                "lang": lang
            }, function (data) {
                if (data.status == 'ok') {
                    if (typeCart == 'modal') {
                        $('.js__type_cart[data-type=modal]').find('.js__update_price').text(data.data.cart_total);
                    }

                    $(`.js__type_cart[data-idCart=${data.data.id_cart}]`)
                        .find('.js__count_input').val(data.data.good_quantity);

                    if (data.data.good_quantity > 1) {
                        $(`.js__type_cart[data-idCart=${data.data.id_cart}]`)
                            .find('.js_count_goods button[data-name="count_minus"]').removeClass('disabled');
                    } else {
                        $(`.js__type_cart[data-idCart=${data.data.id_cart}]`)
                            .find('.js_count_goods button[data-name="count_minus"]').addClass('disabled');
                    }

                    $('.js__all_active').attr('data-type_active', data.data.cart_quantity == data.data.cart_quantity_total ? 'all' : 'not_all');
                    $('.js__all_active .js__all_good_to_cart').empty().text(data.data.cart_quantity_total);
                    $('.js__all_active .js__all_good_active_to_cart').empty().text(data.data.cart_quantity);

                    $('.cart_header .total_info .count, .cart_model_checkout .total_info .count').text(data.data.cart_quantity);
                    $('.cart_header .total_info .price span, .cart_model_checkout .total_info .price span').text(data.data.cart_total);
                    $('.js__quantity').text(data.data.cart_quantity);

                    if ($('.js__main_page_info').length > 0) {
                        $('.js__main_page_info .main_page_user_tool_bar_text span').text(data.data.cart_total);
                    }

                    if ($('.js__append_mini_cart').length > 0 && typeof data.data.html_mini_cart != 'undefined') {
                        $('.js__append_mini_cart').empty().append(data.data.html_mini_cart);
                    }

                    if (data.data.cart_total != 0 && Number(data.data.cart_total.split(' ').join('')) > 0) {
                        $('.cart_header .total_info .price, .cart_model_checkout .total_info .price').show();
                    }

                    if ($('.js__send_checkout').length > 0) {
                        $('.js__open_mini_cart span').empty().text(data.data.cart_quantity);
                        $('.js__update_quantity').empty().text(data.data.cart_quantity_text);
                        $('.js__update_total_sum').empty().text(data.data.cart_total);
                        $('.js__update_total_sum[data-total]').attr('data-total', data.data.cart_total.replace(/\s+/g, ''))

                        checkoutTools.updateTotalPrice();
                    }

                    let good_object = JSON.parse(localStorage.getItem(dataQuantity['id_cart']));

                    if (good_object !== null) {
                        good_object[1].quantity = Number(input.val());
                        good_object[0].quantity = 1;

                        if (nameButton == 'count_plus') {
                            dataLayer.push({
                                ecommerce: null
                            });
                            dataLayer.push({
                                event: "add_to_cart",
                                label: "main",
                                ecommerce: {
                                    items: [good_object[0]]
                                }
                            });
                        }

                        localStorage.setItem(dataQuantity['id_cart'], JSON.stringify(good_object));

                        if (garantyKey) {
                            let good_object_garant = JSON.parse(localStorage.getItem(garantyKey));
                            good_object_garant[1].quantity = Number(input.val());


                            if (nameButton == 'count_plus') {
                                dataLayer.push({
                                    ecommerce: null
                                });
                                dataLayer.push({
                                    event: "add_to_cart",
                                    label: "main",
                                    ecommerce: {
                                        items: [good_object_garant[0]]
                                    }
                                });
                            }

                            localStorage.setItem(garantyKey, JSON.stringify(good_object_garant));
                        }
                    }
                }
            });
        }
    });

    $(document).on('input', '.js__count_input', function () {
        const input = $(this);
        let inputValue = input.val();
        let digitsOnly;

        if (inputValue != '') {
            let minCount = parseInt(input.attr('data-minCount')) || 0;
            let maxCount = parseInt(input.attr('data-maxCount')) || Infinity;
            digitsOnly = inputValue.replace(/\D/g, '');
            digitsOnly = Math.max(minCount, Math.min(parseInt(digitsOnly), maxCount));
        } else {
            digitsOnly = 1;
        }

        input.val(digitsOnly);
    });

    $(document).on('click', '.js__delete_good_cart', function () {
        const idCart = $(this).attr('data-idCart');
        const typeCart = $(this).closest('.js__type_cart').attr('data-type');

        let is_garanty = false;

        if ($(this).closest('.js__update_block_gtm').find('.js__garanty_count').length > 0) {
            is_garanty = $(this).closest('.js__update_block_gtm').find('.js__garanty_count').attr('data-garanty_key');
        }

        $.post(request.removeCart, {
            "id_cart": idCart,
            "cart_good_guids": toolsCartGoodsBuy.getGoods(),
            "is_garanty": 0,
            "lang": lang
        }, function (data) {
            if (data.status == 'ok') {
                if (typeCart == 'modal') {
                    $('.js__type_cart[data-type=modal]').find('.js_close_modal').trigger('click');
                } else if (typeCart == 'checkout_cart') {
                    if (data.data.cart_total == 0 && data.data.cart_quantity == 0) {
                        $('.next_step').hide();
                    } else {
                        $('.next_step').show();
                    }

                    if (data.data.cart_total == 0 && data.data.cart_quantity == 0 && data.data.full_cart_quantity == 0) {
                        window.location.href = '/'
                    }
                }

                $('.js__all_active').attr('data-type_active', data.data.cart_quantity == data.data.cart_quantity_total ? 'all' : 'not_all');
                $('.js__all_active .js__all_good_to_cart').empty().text(data.data.cart_quantity_total);
                $('.js__all_active .js__all_good_active_to_cart').empty().text(data.data.cart_quantity);

                $(`.js__type_cart[data-idCart=${idCart}]`).remove();
                $('.cart_header .total_info .count, .cart_model_checkout .total_info .count').text(data.data.cart_quantity);
                $('.cart_header .total_info .price span, .cart_model_checkout .total_info .price span').text(data.data.cart_total);
                $('.js__quantity').text(data.data.cart_quantity);

                if ($('.js__main_page_info').length > 0) {
                    $('.js__main_page_info .main_page_user_tool_bar_text span').text(data.data.cart_total);
                }

                if (data.data.cart_total != 0 && Number(data.data.cart_total.split(' ').join('')) > 0) {
                    $('.cart_header .total_info .price, .cart_model_checkout .total_info .price').show();
                }

                if (data.data.cart_quantity_total == 0) {
                    $('.block_add_cart').addClass('hide');
                    $('.cart_empty.header_cart').removeClass('hide');
                }

                if ($('.js__send_checkout').length > 0) {
                    $('.js__open_mini_cart span').empty().text(data.data.cart_quantity);
                    $('.js__update_quantity').empty().text(data.data.cart_quantity_text);
                    $('.js__update_total_sum').empty().text(data.data.cart_total);
                    $('.js__update_total_sum[data-total]').attr('data-total', data.data.cart_total.replace(/\s+/g, ''))

                    checkoutTools.updateTotalPrice();
                }

                if ($('.js__append_mini_cart').length > 0 && typeof data.data.html_mini_cart != 'undefined') {
                    $('.js__append_mini_cart').empty().append(data.data.html_mini_cart);
                }

                localStorage.removeItem(idCart);

                if (is_garanty) {
                    localStorage.removeItem(is_garanty);
                }

                // updateTotalSumForFondy(data);
            }
        });
    });

    $(document).on('click', '.js_wishlist', function () {
        const button = $(this);
        const id = button.attr('data-id');
        const addWishlist = button.hasClass('add_to_wishlist')
            ? 'removeFromWishlist'
            : 'getWishlists';

        let objectData = {
            "lang": lang,
            "id": id,
            "item_type": button.attr('data-item_type')
        };

        $.post(request[addWishlist], objectData, function (data) {
            if (data.status == 'ok') {
                if (addWishlist == 'getWishlists') {
                    $('footer').after('<div class="bg_modal_window"></div>');
                    $('.modal_wrap[data-modal="listWishlist"]').addClass('js_open_modal');
                    $('.modal_wrap[data-modal="listWishlist"] .js__list_wishlist').empty().append(data.html);
                    $('.js__list_wishlist .js__good_id').val(objectData.id);
                    $('.js__list_wishlist .js__item_type').val(objectData.item_type);
                    $('.js__item_wishlist').attr({
                        "data-good_id": objectData.id,
                        "data-item_type": objectData.item_type
                    });
                    button.addClass('js__anker_here');
                } else {
                    $(`.js_wishlist[data-id=${id}]`).removeClass('add_to_wishlist')
                }
            }
        });
    });

    $(document).on('click', '.js__trigger_btn_buy', function () {
        $('.js_price_html .js__add_cart').trigger('click');
    })

    $(document).on('click', '.js__add_list_wishlist', function (e) {
        $(this).addClass('js__hidden');
        $(this).closest('.add_list_wishlist').find('.new_list').addClass('js__active');
        $(this).closest('.js__list_wishlist').find('.list_wishlist').addClass('js__hidden');
    });

    $(document).on('click', '.js__add_new_wishlist', function () {
        const block = $(this).closest('.new_list');

        if (block.find('input').val() == "") {
            block.find('input').addClass('input_error');
        } else {
            block.find('input').removeClass('input_error');
            let value = {};
            block.find('input').each(function () {
                const name = $(this).attr('name');
                const valueInput = $(this).val();
                value[name] = valueInput;
            });

            $.post(request.addWishlist, value, function (data) {
                if (data.status == 'ok') {
                    $(`.js_wishlist[data-id=${value.good_id}]`).addClass('add_to_wishlist')
                    $('.js__anker_here').removeClass('js__anker_here');
                    $('.bg_modal_window').trigger('click');
                }
            });
        }
    });

    $(document).on('click', '.js__item_wishlist', function () {
        const id = $(this).attr('data-good_id');
        const object = {
            "good_id": id,
            "wishlist_id": $(this).attr('data-wishlist'),
            "item_type": $(this).attr('data-item_type'),
            "is_remains_tracking": 0,
            "is_price": 1,
        }

        $.post(request.addToWishlist, object, function (data) {
            if (data.status == 'ok') {
                $(`.js_wishlist[data-id=${id}]`).addClass('add_to_wishlist')
                $('.js__anker_here').removeClass('js__anker_here');
            }
        });
    })

    $(document).on('click', '.js__gtm_link', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let buttonInfo = '';

        if (typeof $(this).attr('data-type') != 'undefined' && $(this).attr('data-type') == 'link') {
            buttonInfo = $(this);
        } else {
            buttonInfo = $(this).closest('.tile_item_wrap').find('.js__gtm_data_saved');
        }

        const gtmItem = {
            'guid': buttonInfo.attr('data-guid'),
            'id': buttonInfo.attr('data-id'),
            'itemlistnamegtm': buttonInfo.attr('data-itemlistnamegtm'),
            'indexgtm': buttonInfo.attr('data-indexgtm')
        }

        localStorage.setItem('gtm_info', JSON.stringify(gtmItem));
        window.location.href = $(this).attr('href');
    });

    $(document).on('click', function (e) {
        const target = $(e.target);

        // Проверяем, кликнули ли вне кнопки `.js__remains_good`
        if (!target.closest('.js__remains_good').length) {
            // Если открыты элементы, удаляем их
            $('.js__info_good_remains_open').remove();
            $('.js__active_remains').removeClass('js__active_remains');
        }
    });

    $(document).on('click', '.js__remains_good', function (e) {
        e.stopPropagation(); // Останавливаем всплытие события

        const id = $(this).attr('data-id');
        const guid = $(this).attr('data-guid');
        const btn = $(this);

        // Если кнопка уже активна, то закрываем блок
        if (btn.hasClass('js__active_remains')) {
            $('.js__info_good_remains_open').remove();
            $('.js__active_remains').removeClass('js__active_remains');
            btn.removeClass('js__active_remains');
        } else {
            // Если кнопка не активна, открываем блок с данными
            $('.js__info_good_remains_open').remove();
            $('.js__active_remains').removeClass('js__active_remains');

            $.post(request.loadRemains, {
                'id': id,
                'guid': guid,
            }, function (data) {
                if (data.status == 'ok') {
                    btn.addClass('js__active_remains');
                    btn.append(data.html);
                }
            });
        }
    });
})